import * as ct from "countries-and-timezones";

export function getAllTimezones(): ct.Timezone[] {
  const timezoneRecord = ct.getAllTimezones();
  const timezones = Object.keys(timezoneRecord).map(key => timezoneRecord[key as ct.TimezoneName]);

  return timezones.sort((a, b) => a.utcOffset - b.utcOffset);
}

export function toSeconds(minutes: number): number {
  return minutes * 60;
}

export function toMinutes(seconds: number): number {
  return seconds / 60;
}